import {
  LayoutDashboard,
  Users,
  FileText,
  Folders,
  UserPlus,
  Building2,
  CreditCard,
  ShieldCheck,
} from "lucide-react";

export interface NavigationItem {
  name: string;
  href: string;
  icon: JSX.Element;
  roles?: string[];
}

export const navigationItems: NavigationItem[] = [
  {
    name: "Dashboard",
    href: "/dashboard",
    icon: <LayoutDashboard size={20} />,
  },
  { name: "Contactos", href: "/contacts", icon: <Users size={20} /> },
  { name: "Documentos", href: "/documents", icon: <FileText size={20} /> },
  { name: "Expedientes", href: "/dossiers", icon: <Folders size={20} /> },
  {
    name: "Gestión de Usuarios",
    href: "/organization/users",
    icon: <UserPlus size={20} />,
    roles: ["ADMIN"],
  },
  {
    name: "Empresas",
    href: "/companies",
    icon: <Building2 size={20} />,
    roles: ["SUPER_ADMIN"],
  },
  {
    name: "Planes",
    href: "/plans",
    icon: <CreditCard size={20} />,
    roles: ["SUPER_ADMIN"],
  },
  {
    name: "Firma del Sistema",
    href: "/system-signing",
    icon: <ShieldCheck size={20} />,
    roles: ["SUPER_ADMIN"],
  },
];

export const getNavigationItems = (userRole?: string): NavigationItem[] => {
  if (!userRole) return navigationItems.filter((item) => !item.roles);

  return navigationItems.filter((item) => {
    if (!item.roles) return true;
    return item.roles.includes(userRole);
  });
};
